import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { useEmblaCarousel } from "embla-carousel/react"

import { useBlogCategories } from "../../GraphQl/useBlogCategories"
import { StandardContainer } from "../common"

const StyledBlogCategoryNav = styled(StandardContainer)`
  width: 100vw;
  overflow: hidden;
  > nav {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-bottom: 2rem;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    > nav {
      justify-content: center;
    }
  }
`

const StyledNavLink = styled(Link)`
  padding: 0.5rem 1.5rem;
  color: #005d73;
  font-weight: 700;
  border-radius: 100px;
  &.active {
    border: 2px solid #005d73;
  }
`

export const BlogCategoryNav = () => {
  const items = useBlogCategories()

  const [emblaRef] = useEmblaCarousel({
    loop: false,
    dragFree: true,
    align: "start",
    containScroll: true,
  })

  return (
    <StyledBlogCategoryNav ref={emblaRef} padH>
      <nav>
        <StyledNavLink to="/resources" activeClassName="active">
          All
        </StyledNavLink>
        {items?.map(
          ({ posts, url, data: { title } }, index) =>
            posts && (
              <StyledNavLink
                index={`${title?.text}-${index}`}
                to={`${url}`}
                activeClassName="active"
              >
                {title?.text}
              </StyledNavLink>
            )
        )}
      </nav>
    </StyledBlogCategoryNav>
  )
}
